<template>
    <div name="count-info" class="wrapper">
        <span class="title">지금까지 <span class="color">{{ count }}</span>개의<br>불편이 접수되었어요!</span>
        <span class="description">솔닥 컨시어지가 함께 해결할 수 있는 방법을 찾고,<br>직접 행동으로 바꿔나가겠습니다.</span>
        <span class="info" style="margin-top: 16px;">* 페이지에 올라오는 사례들은 프로젝트 참여자들이 실제 제출한 의견이며,<br>비속어나 욕설 타인의 개인정보 등 부적절한 표현은 걸러질 수 있습니다.</span>
    </div>
</template>

<script>
export default {
    name: 'countInfo',
    props: ['count']
}
</script>

<style scoped>
    .wrapper {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        background: #212529;
        flex-direction: column;
    }
    .title {
        color: var(--Gray-00, #FFF);
        font-family: Pretendard;
        font-size: 40px;
        font-style: normal;
        font-weight: 600;
        line-height: 44px; /* 110% */
    }
    .color {
        color: var(--Blue-01_Primary-blue, #008DEF);
        font-family: Pretendard;
        font-size: 40px;
        font-style: normal;
        font-weight: 600;
        line-height: 44px;
    }
    .description{
        color: var(--Gray-00, #FFF);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 125% */
        margin-top: 16px;
    }
    .info {
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
</style>


// WEBPACK FOOTER //
// src/components/molecules/pc_uncomfortable/CountInfo.vue